import { DataDrivenPropertyValueSpecification } from "mapbox-gl";

interface MakeOnHoverExpressionOptions<T> {
    defaultValue: T;
    hoveredMapEditorFeatureId: string | undefined;
    hoveredValue: T;
}

export function makeOnHoverExpression<T>(options: MakeOnHoverExpressionOptions<T>): DataDrivenPropertyValueSpecification<T> {
    if (!options.hoveredMapEditorFeatureId) {
        return options.defaultValue;
    }

    return ["case", ["==", ["get", "id"], options.hoveredMapEditorFeatureId], options.hoveredValue, options.defaultValue];
}
